const handleFileAdditionalSource = (file) => {
  return !file?.additionalImage?.photo && !file?.additionalImage?.url
    ? file?.additionalImage?.originalFile
      ? URL.createObjectURL(file?.additionalImage?.originalFile)
      : null
    : file?.additionalImage?.photo || file?.additionalImage?.url;
};
export default handleFileAdditionalSource;
